<template>
	<div class="compiled-container" v-loading="compiledLoading">

		<el-alert
			v-if="error"
			title="Ha ocurrido un error"
			type="error"
			center
			:closable="false">
		</el-alert>

		<template v-else>
			<div v-html="html"></div>
		</template>

	</div>
</template>

<script>
	import { getDataCompiled } from '@/helpers/api'

	function init() {
		console.log('Hola')
	}
	export default {
		name: 'Compiled',
		props: {
			entidad: String,
			id: String,
			ficha: [String, Object],
			porlet: Object,
			componente: String
		},
		data() {
			return {
				html: null,
				compiledLoading: false,
				error: false
			}
		},
		mounted () {
			this.init()
		},
		methods: {
			init() {

				this.getData()
			},
			async getData() {

				this.compiledLoading = true

				try {
						
					let resp = await getDataCompiled(this.porlet.entidadRelacionada)

					if (resp.status == 200 && typeof resp.data == 'object') {

						this.html = resp.data.html

						if(resp.data.css) document.head.innerHTML += resp.data.css

						if(resp.data.js) {

							var s = document.createElement('script');

							s.type = 'text/javascript';
							s.innerText = resp.data.js;
							document.getElementsByTagName('head')[0].appendChild(s);
						}
						
					} else {
						//console.log('error datos')
						this.error = true
					}

				} catch(err) {
					//console.log('error cacth datos')
					console.log(err)
					this.error = true
				}

				this.compiledLoading = false

			}
		}
	}
</script>

<style lang="scss">
.compiled-container {
	
}
</style>